import React from 'react';

function EditUserForm({ user, name, setName, email, setEmail, group, setGroup }) {

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Edit Profile</label>
            <form>
                <div className="mb-4">
                    <label
                        htmlFor="userName"
                        className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                    >
                        Name
                    </label>
                    <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        id="userName"
                        name='name'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder={user.name}
                    />
                </div>
                <div className="mb-4">
                    <label
                        htmlFor="userEmail"
                        className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                    >
                        Email
                    </label>
                    <input
                        type="email"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        id="userEmail"
                        name='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={user.email}
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="group" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Group
                    </label>
                    <input
                        id="group"
                        name="group"
                        type="group"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        value={group}
                        onChange={(e) => setGroup(e.target.value)}
                    />
                </div>
            </form>
        </div>
    )
}

export default EditUserForm
